:host {
  width: var(--avatar-size);
  min-width: var(--avatar-size);
  max-height: var(--avatar-size);
  font-size: var(--avatar-font-size);

  --avatar-color: var(--theme-5);
  --avatar-color-dark: var(--theme-7);
  --avatar-font-color: var(--white);
  --avatar-size: 2rem;
  --avatar-font-size: 1rem;
  --avatar-text-shadow: 0 0 0px rgba(255, 255, 255, 0.4);
  --shadow-size: 2px;

  filter: drop-shadow(var(--drop-shadow));
}

:host([size='tiny']) {
  --avatar-size: 1.5rem;
  --avatar-font-size: 1rem;
  --shadow-size: 1px;
}

:host([size='small']) {
  --avatar-size: 1.75rem;
  --avatar-font-size: 1.25rem;
  --shadow-size: 2px;
}

:host([size='small'][shape='rectangle']) {
  --avatar-font-size: 0.875rem;
}

:host([size='medium-small']) {
  --avatar-size: 2.25rem;
  --avatar-font-size: 1.15rem;
  --shadow-size: 2.5px;
}

:host([size='medium']) {
  --avatar-size: 3rem;
  --avatar-font-size: 1.25rem;
  --shadow-size: 3px;
}

:host([size='large']) {
  --avatar-size: 5rem;
  --avatar-font-size: 2.5rem;
  --shadow-size: 4px;
}

:host([size='xlarge']) {
  --avatar-size: 7.5rem;
  --avatar-font-size: 3.5rem;
  --shadow-size: 6px;
}

:host([size='huge']) {
  --avatar-size: 10rem;
  --avatar-font-size: 5.5rem;
  --shadow-size: 8px;
}

:host .wrapper {
  display: block;
  position: relative;
  z-index: 0;
  width: 100%;
  max-width: 2.2em;
  font: inherit;
  font-size: var(--avatar-font-size);
  appearance: none;
  border: none;
  padding: 0;
  background: transparent;
}

:host .content {
  overflow: hidden;
  position: relative;
  transition: filter 100ms var(--ease) 0s;
}

:host .spacer {
  display: block;
  background: var(--avatar-color);
  background: linear-gradient(45deg, var(--avatar-color) 0%, var(--avatar-color-dark) 100%);
  padding-top: 100%;
  width: 100%;
  height: 0;
}

:host .spacer {
  filter: drop-shadow(0px var(--shadow-size) 0 var(--theme-7)) drop-shadow(0px calc(var(--shadow-size) * -1) 0 var(--theme-7)) drop-shadow(var(--shadow-size) 0px 0 var(--theme-7))
    drop-shadow(calc(var(--shadow-size) * -1) 0px 0 var(--theme-7));
}

:host([src]) .spacer {
  filter: none;
}

:host .image .spacer {
  background: transparent;
}

:host .letter {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  z-index: 1;
  width: 100%;
  height: 100%;
  text-align: center;
  text-transform: lowercase;
  line-height: 100%;
  padding: 0 0.4em 0.2em;
  color: var(--avatar-font-color);
  font-size: var(--avatar-font-size);
  font-weight: 600;
  text-shadow: var(--avatar-text-shadow);
}

:host img {
  position: absolute;
  top: 50%;
  right: 50%;
  bottom: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  border-radius: inherit;
  background: transparent;
  width: 100%;
  height: 100%;
  color: transparent;
  object-fit: cover;
}

/* Shapes */

/* Shapes: Square */
:host([shape='circle']) .wrapper,
:host([shape='circle']) .content,
:host([shape='circle']) .spacer {
  border-radius: 100%;
}

:host([shape='squircle']) .wrapper,
:host([shape='squircle']) .content,
:host([shape='squircle']) .spacer {
  clip-path: polygon(100% 50%, 100% 56.6%, 100% 59.3%, 100% 61.4%, 99.9% 63.2%, 99.9% 64.8%, 99.9% 66.2%, 99.8% 67.5%, 99.8% 68.7%, 99.7% 69.8%, 99.6% 70.8%, 99.5% 71.8%, 99.5% 72.8%, 99.4% 73.7%, 99.3% 74.6%, 99.1% 75.4%, 99% 76.3%, 98.9% 77%, 98.8% 77.8%, 98.6% 78.5%, 98.5% 79.2%, 98.3% 79.9%, 98.1% 80.6%, 98% 81.3%, 97.8% 81.9%, 97.6% 82.5%, 97.4% 83.1%, 97.2% 83.7%, 97% 84.3%, 96.8% 84.8%, 96.5% 85.4%, 96.3% 85.9%, 96% 86.4%, 95.8% 86.9%, 95.5% 87.4%, 95.3% 87.9%, 95% 88.3%, 94.7% 88.8%, 94.4% 89.2%, 94.1% 89.7%, 93.8% 90.1%, 93.4% 90.5%, 93.1% 90.9%, 92.8% 91.3%, 92.4% 91.7%, 92% 92%, 91.7% 92.4%, 91.3% 92.8%, 90.9% 93.1%, 90.5% 93.4%, 90.1% 93.8%, 89.7% 94.1%, 89.2% 94.4%, 88.8% 94.7%, 88.3% 95%, 87.9% 95.3%, 87.4% 95.5%, 86.9% 95.8%, 86.4% 96%, 85.9% 96.3%, 85.4% 96.5%, 84.8% 96.8%, 84.3% 97%, 83.7% 97.2%, 83.1% 97.4%, 82.5% 97.6%, 81.9% 97.8%, 81.3% 98%, 80.6% 98.1%, 79.9% 98.3%, 79.2% 98.5%, 78.5% 98.6%, 77.8% 98.8%, 77% 98.9%, 76.3% 99%, 75.4% 99.1%, 74.6% 99.3%, 73.7% 99.4%, 72.8% 99.5%, 71.8% 99.5%, 70.8% 99.6%, 69.8% 99.7%, 68.7% 99.8%, 67.5% 99.8%, 66.2% 99.9%, 64.8% 99.9%, 63.2% 99.9%, 61.4% 100%, 59.3% 100%, 56.6% 100%, 50% 100%, 43.4% 100%, 40.7% 100%, 38.6% 100%, 36.8% 99.9%, 35.2% 99.9%, 33.8% 99.9%, 32.5% 99.8%, 31.3% 99.8%, 30.2% 99.7%, 29.2% 99.6%, 28.2% 99.5%, 27.2% 99.5%, 26.3% 99.4%, 25.4% 99.3%, 24.6% 99.1%, 23.7% 99%, 23% 98.9%, 22.2% 98.8%, 21.5% 98.6%, 20.8% 98.5%, 20.1% 98.3%, 19.4% 98.1%, 18.7% 98%, 18.1% 97.8%, 17.5% 97.6%, 16.9% 97.4%, 16.3% 97.2%, 15.7% 97%, 15.2% 96.8%, 14.6% 96.5%, 14.1% 96.3%, 13.6% 96%, 13.1% 95.8%, 12.6% 95.5%, 12.1% 95.3%, 11.7% 95%, 11.2% 94.7%, 10.8% 94.4%, 10.3% 94.1%, 9.9% 93.8%, 9.5% 93.4%, 9.1% 93.1%, 8.7% 92.8%, 8.3% 92.4%, 8% 92%, 7.6% 91.7%, 7.2% 91.3%, 6.9% 90.9%, 6.6% 90.5%, 6.2% 90.1%, 5.9% 89.7%, 5.6% 89.2%, 5.3% 88.8%, 5% 88.3%, 4.7% 87.9%, 4.5% 87.4%, 4.2% 86.9%, 4% 86.4%, 3.7% 85.9%, 3.5% 85.4%, 3.2% 84.8%, 3% 84.3%, 2.8% 83.7%, 2.6% 83.1%, 2.4% 82.5%, 2.2% 81.9%, 2% 81.3%, 1.9% 80.6%, 1.7% 79.9%, 1.5% 79.2%, 1.4% 78.5%, 1.2% 77.8%, 1.1% 77%, 1% 76.3%, 0.9% 75.4%, 0.7% 74.6%, 0.6% 73.7%, 0.5% 72.8%, 0.5% 71.8%, 0.4% 70.8%, 0.3% 69.8%, 0.2% 68.7%, 0.2% 67.5%, 0.1% 66.2%, 0.1% 64.8%, 0.1% 63.2%, 0% 61.4%, 0% 59.3%, 0% 56.6%, 0% 50%, 0% 43.4%, 0% 40.7%, 0% 38.6%, 0.1% 36.8%, 0.1% 35.2%, 0.1% 33.8%, 0.2% 32.5%, 0.2% 31.3%, 0.3% 30.2%, 0.4% 29.2%, 0.5% 28.2%, 0.5% 27.2%, 0.6% 26.3%, 0.7% 25.4%, 0.9% 24.6%, 1% 23.7%, 1.1% 23%, 1.2% 22.2%, 1.4% 21.5%, 1.5% 20.8%, 1.7% 20.1%, 1.9% 19.4%, 2% 18.7%, 2.2% 18.1%, 2.4% 17.5%, 2.6% 16.9%, 2.8% 16.3%, 3% 15.7%, 3.2% 15.2%, 3.5% 14.6%, 3.7% 14.1%, 4% 13.6%, 4.2% 13.1%, 4.5% 12.6%, 4.7% 12.1%, 5% 11.7%, 5.3% 11.2%, 5.6% 10.8%, 5.9% 10.3%, 6.2% 9.9%, 6.6% 9.5%, 6.9% 9.1%, 7.2% 8.7%, 7.6% 8.3%, 8% 8%, 8.3% 7.6%, 8.7% 7.2%, 9.1% 6.9%, 9.5% 6.6%, 9.9% 6.2%, 10.3% 5.9%, 10.8% 5.6%, 11.2% 5.3%, 11.7% 5%, 12.1% 4.7%, 12.6% 4.5%, 13.1% 4.2%, 13.6% 4%, 14.1% 3.7%, 14.6% 3.5%, 15.2% 3.2%, 15.7% 3%, 16.3% 2.8%, 16.9% 2.6%, 17.5% 2.4%, 18.1% 2.2%, 18.7% 2%, 19.4% 1.9%, 20.1% 1.7%, 20.8% 1.5%, 21.5% 1.4%, 22.2% 1.2%, 23% 1.1%, 23.7% 1%, 24.6% 0.9%, 25.4% 0.7%, 26.3% 0.6%, 27.2% 0.5%, 28.2% 0.5%, 29.2% 0.4%, 30.2% 0.3%, 31.3% 0.2%, 32.5% 0.2%, 33.8% 0.1%, 35.2% 0.1%, 36.8% 0.1%, 38.6% 0%, 40.7% 0%, 43.4% 0%, 50% 0%, 56.6% 0%, 59.3% 0%, 61.4% 0%, 63.2% 0.1%, 64.8% 0.1%, 66.2% 0.1%, 67.5% 0.2%, 68.7% 0.2%, 69.8% 0.3%, 70.8% 0.4%, 71.8% 0.5%, 72.8% 0.5%, 73.7% 0.6%, 74.6% 0.7%, 75.4% 0.9%, 76.3% 1%, 77% 1.1%, 77.8% 1.2%, 78.5% 1.4%, 79.2% 1.5%, 79.9% 1.7%, 80.6% 1.9%, 81.3% 2%, 81.9% 2.2%, 82.5% 2.4%, 83.1% 2.6%, 83.7% 2.8%, 84.3% 3%, 84.8% 3.2%, 85.4% 3.5%, 85.9% 3.7%, 86.4% 4%, 86.9% 4.2%, 87.4% 4.5%, 87.9% 4.7%, 88.3% 5%, 88.8% 5.3%, 89.2% 5.6%, 89.7% 5.9%, 90.1% 6.2%, 90.5% 6.6%, 90.9% 6.9%, 91.3% 7.2%, 91.7% 7.6%, 92% 8%, 92.4% 8.3%, 92.8% 8.7%, 93.1% 9.1%, 93.4% 9.5%, 93.8% 9.9%, 94.1% 10.3%, 94.4% 10.8%, 94.7% 11.2%, 95% 11.7%, 95.3% 12.1%, 95.5% 12.6%, 95.8% 13.1%, 96% 13.6%, 96.3% 14.1%, 96.5% 14.6%, 96.8% 15.2%, 97% 15.7%, 97.2% 16.3%, 97.4% 16.9%, 97.6% 17.5%, 97.8% 18.1%, 98% 18.7%, 98.1% 19.4%, 98.3% 20.1%, 98.5% 20.8%, 98.6% 21.5%, 98.8% 22.2%, 98.9% 23%, 99% 23.7%, 99.1% 24.6%, 99.3% 25.4%, 99.4% 26.3%, 99.5% 27.2%, 99.5% 28.2%, 99.6% 29.2%, 99.7% 30.2%, 99.8% 31.3%, 99.8% 32.5%, 99.9% 33.8%, 99.9% 35.2%, 99.9% 36.8%, 100% 38.6%, 100% 40.7%, 100% 43.4%);
}

/* Shapes: Rectangle */
:host([shape='rectangle']) .spacer {
  padding-top: 60%;
}

:host([shape='rectangle']) .letter {
  padding: 0;
}

/* Shapes: Diamond */
:host([shape='diamond']) .spacer {
  clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
}

/* Shapes: Diamond */
:host([shape='hexagon']) .spacer {
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
}

/* Shapes: Star */
:host([shape='star']) .spacer {
  clip-path: polygon(50% 0%, 64% 27%, 98% 35%, 74% 57%, 79% 91%, 50% 76%, 21% 91%, 25% 57%, 2% 35%, 36% 28%);
}

/* Shapes: Message */
:host([shape='message']) .spacer {
  clip-path: polygon(0% 0%, 100% 0%, 100% 75%, 75% 75%, 75% 100%, 50% 75%, 0% 75%);
}

/* Processing */

/* Processing */
:host([processing]:not([processing='false'])) midwest-progress {
  font-size: 1.5em;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  color: white;
}

:host([processing]:not([processing='false'])) .content {
  filter: blur(10px) grayscale(75%);
}

:host([processing][shape='rectangle']:not([processing='false'])) midwest-progress,
:host([processing][shape='star']:not([processing='false'])) midwest-progress,
:host([processing][shape='diamond']:not([processing='false'])) midwest-progress,
:host([processing][shape='hexagon']:not([processing='false'])) midwest-progress {
  font-size: 1em;
}

:host([dark]) {
  --avatar-color: var(--theme-5, var(--red-5));
  --avatar-color-dark: var(--theme-6, var(--red-6));
  --avatar-font-color: var(--theme-1);
  --avatar-text-shadow: 0 0 0px rgba(0, 0, 0, 0.4);
  filter: none;
}

:host([processing][dark]:not([processing='false'])) midwest-progress {
  --theme-9: white !important;
  --theme-8: white !important;
  --theme-7: white !important;
}
